import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@chakra-ui/react';
import {
  FaRegClock,
  FaSearch,
  FaEye,
  FaEdit
} from "react-icons/fa";
import { useColorModeValue } from '../../components/ui/color-mode';
import FitTabs from '../../components/shared/tabs/Tabs';
import { Header } from '../../components/shared/IndexHeader';
import { Overview } from '../../components/shared/OverviewTab';
import { ListComponent } from '../../components/shared/ListTab';
import styles from './product.module.css';
import { darkMode, lightMode } from '../../theme/config';
import { insightsPath, listPath } from '../../utils/constants/insightsPath';
import { useDispatch, useSelector } from 'react-redux';
import { resetFilterData } from '../../store/filterSlice';
import { loadModelsRequest, setShowModelsState } from '../../store/modelsSlice';
import { formatProductsData } from '../../utils/dataFormatters';
import SelectBox from '../../components/shared/fields/SelectBox';
import { useForm } from 'react-hook-form';
import { dateRangeOptions } from '../home/dashboardConstants';

const columns = [
  { key: "serialNo", label: "Serial No.", width: "7%", textAlign: "center" },
  { key: "purchaseDate", label: "Purchase Date", width: "10%", textAlign: "center" },
  { key: "name", label: "Model Name", width: "12%", textAlign: "center" },
  { key: "category", label: "Product Category", width: "13%", textAlign: "center" },
  { key: "subCategory", label: "Product Sub Category", width: "16%", textAlign: "center" },
  { key: "primaryWarranty", label: "Primary Warranty", width: "12%", textAlign: "center" },
  { key: "extendedWarranty", label: "Extended Warranty", width: "12%", textAlign: "center" },
  // { key: "warrantyStatus", label: "Warranty Status", width: "12%", textAlign: "center" },
  { key: "waarantyValidDate", label: "Expiry Date", width: "10%", textAlign: "center" },
];

const ProductIndex = () => {

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadModelsRequest());
  }, [dispatch]);

  useEffect(() => {
    dispatch(resetFilterData({ key: listPath.PRODUCT }));
    dispatch(setShowModelsState(true));
  }, [dispatch]);

  const [activeTab, setActiveTab] = useState("tab-1");
  const borderColor = useColorModeValue(lightMode.containerBorderColor, darkMode.containerBorderColor);
  const textColor = useColorModeValue(lightMode.textColor, darkMode.textColor);
  const { control } = useForm();
  const { productCategories, productSubcategories } = useSelector((state) => state.categories || {
    productCategories: [],
    productSubcategories: {}
  });

  const productList = useSelector((state) => state.list[listPath.PRODUCT] || {
    rows: [],
  });
  const { models } = useSelector((state) => state.models || { models: [] });

  const formattedProducts = formatProductsData(
    productList.rows,
    productCategories,
    productSubcategories,
    models,
  );

  const categoryData = useSelector((state) => state.categories || {
    productCategories: [],
    productSubcategories: {}
  });


  const tabsData = useMemo(() => [
    {
      value: "tab-1",
      label: <><FaRegClock />Overview</>,
      panel: (
        <Overview
          path={insightsPath.PRODUCT}
          source="PRODUCT"
        />
      )
    },
    {
      value: "tab-2",
      label: <><FaSearch />Product List</>,
      panel: (
        <ListComponent
          path={listPath.PRODUCT}
          borderColor={borderColor}
          searchPlaceholder="Search by customer..."
          columns={columns}
          formatData={() => formattedProducts}
          actions={[
            { name: "View", icon: <FaEye />, function: (row) => alert(`Viewing ${row.name}`) },
            { name: "Edit", icon: <FaEdit />, function: (row) => alert(`Editing ${row.name}`) }
          ]}
          categoryOptions={categoryData.productCategories}
          subCategoryOptions={categoryData.productSubcategories}
          exportButtonLabel="Export"
          source="REGISTRATION"
        />
      )
    }
  ], [
    formattedProducts,
    borderColor,
    categoryData.productCategories,
    categoryData.productSubcategories
  ]);

  const handleTabChange = (newTabValue) => {
    setActiveTab(newTabValue.value);
  };

  return (
    <Box className={styles.container}>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Box width={"70%"}>
          <Header
            title="Product Registrations"
            subtitle="View and manage all registered products"
            textColor={textColor}
          />
        </Box>
        <Box width={"20%"}>
          <SelectBox
            label="Date Range"
            name="dateRange"
            control={control}
            items={dateRangeOptions}
            placeholder="Last 30 Days"
            disabled={true}
          />
        </Box>
      </Box>
      <FitTabs
        tabs={tabsData}
        value={activeTab}
        onChange={handleTabChange}
        variant="enclosed"
        width="100%"
        fitted
      />
    </Box>
  );
};

export default ProductIndex;